import { pxToRem } from 'taboola-ultimate-ui';
import styles from './commonPickerDropdownStyle.module.scss';

export const pickerDropdownWidth = 372;
export const pickerDropdownSafePadding = 5;

export const commonPickerDropdownStyle = {
    container: provided => ({
        ...provided,
        width: pxToRem(pickerDropdownWidth),
        borderRadius: 4,
        backgroundColor: 'white',
        zIndex: 1,
        boxShadow: `0 ${pxToRem('2px')} ${pxToRem('4px')} 0 rgba(0, 0, 0, 0.2)`,
    }),
    control: provided => ({
        ...provided,
        boxShadow: 'none',
        outline: 'none',
        border: 'none',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderBottom: `1px solid ${styles.borderColor}`,
        flexDirection: 'row-reverse',
        minHeight: pxToRem(48),

        '&:hover': {
            borderBottom: `1px solid ${styles.borderColor}`,
        },
    }),
    menu: () => ({
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
    }),
    menuList: provided => ({
        ...provided,
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        overflow: 'auto',
        maxHeight: '80vh',
    }),
    noOptionsMessage: provided => ({
        ...provided,
    }),
};
